import authMiddleware from './auth.middleware';
import loadBusinessInfoMiddleware from './loadBusinessInfo.middleware';
import subscriptionEntitlementMiddleware from './subscriptionEntitlement.middleware';
import mobileInstallMiddleware from './mobileInstall.middleware';
import roleMiddleware from './role.middleware';

export default {
	mobileInstallMiddleware,
	authMiddleware,
	roleMiddleware,
	loadBusinessInfoMiddleware,
	subscriptionEntitlementMiddleware,
};
